// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.geolocateIpDialogRoot[data-v-362d9c3f]
	{
		max-width: 600px;
		background-color: #FFFFFF;
}
.titleBar[data-v-362d9c3f]
	{
		background-color: #FFFFFF;
		padding: 8px 14px;
		box-sizing: border-box;
}
.title[data-v-362d9c3f]
	{
		text-align: center;
		color: black;
		font-weight: bold;
		font-size: 16pt;
}
.dialogBody[data-v-362d9c3f]
	{
		padding: 0px 5px 0px 5px;
}
.buttons[data-v-362d9c3f]
	{
		display: flex;
}
.dialogButton[data-v-362d9c3f]
	{
		display: inline-block;
		cursor: pointer;
		color: #4A9E42;
		font-weight: bold;
		font-size: 12pt;
		box-sizing: border-box;
		position: relative;
		padding: 12px 5px;
		flex: 1 0 auto;
		text-align: center;
}
.dialogButton[data-v-362d9c3f]:hover
		{
			background-color: rgba(0,0,0,0.05);
}
.embedded[data-v-362d9c3f]
	{
		margin: 10px 5px;
}
`, "",{"version":3,"sources":["webpack://./www/vues/common/controls/GeolocateIPPopup.vue"],"names":[],"mappings":";AA4CC;;EAEC,gBAAgB;EAChB,yBAAyB;AAC1B;AAEA;;EAEC,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;AACvB;AAEA;;EAEC,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AAChB;AAEA;;EAEC,wBAAwB;AACzB;AAEA;;EAEC,aAAa;AACd;AAEA;;EAEC,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACnB;AAEC;;GAEC,kCAAkC;AACnC;AAED;;EAEC,gBAAgB;AACjB","sourcesContent":["<template>\r\n\t<div class=\"geolocateIpDialogRoot\" role=\"dialog\" aria-labelledby=\"geolocateIpTitle\">\r\n\t\t<div class=\"titleBar\">\r\n\t\t\t<div id=\"geolocateIpTitle\" class=\"title\" role=\"alert\">Geolocation Information for {{ip}}</div>\r\n\t\t</div>\r\n\t\t<div class=\"dialogBody\">\r\n\t\t\t<GeolocationEmbed :ip=\"ip\" class=\"embedded\" />\r\n\t\t\t<div class=\"buttons\">\r\n\t\t\t\t<div ref=\"closeBtn\" class=\"dialogButton\" tabindex=\"0\" @click=\"DefaultClose\" @keydown.space.enter.prevent=\"DefaultClose\">\r\n\t\t\t\t\tClose\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n</template>\r\n\r\n<script>\r\n\timport GeolocationEmbed from 'appRoot/vues/common/controls/GeolocationEmbed.vue';\r\n\r\n\texport default {\r\n\t\tcomponents: { GeolocationEmbed },\r\n\t\tprops:\r\n\t\t{\r\n\t\t\tip: {\r\n\t\t\t\ttype: String,\r\n\t\t\t\tdefault: \"\"\r\n\t\t\t}\r\n\t\t},\r\n\t\tmethods:\r\n\t\t{\r\n\t\t\tSetFocus()\r\n\t\t\t{\r\n\t\t\t\tif (this.$refs.closeBtn)\r\n\t\t\t\t\tthis.$refs.closeBtn.focus();\r\n\t\t\t},\r\n\t\t\tDefaultClose()\r\n\t\t\t{\r\n\t\t\t\tthis.$emit(\"close\");\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n</script>\r\n\r\n<style scoped>\r\n\t.geolocateIpDialogRoot\r\n\t{\r\n\t\tmax-width: 600px;\r\n\t\tbackground-color: #FFFFFF;\r\n\t}\r\n\r\n\t.titleBar\r\n\t{\r\n\t\tbackground-color: #FFFFFF;\r\n\t\tpadding: 8px 14px;\r\n\t\tbox-sizing: border-box;\r\n\t}\r\n\r\n\t.title\r\n\t{\r\n\t\ttext-align: center;\r\n\t\tcolor: black;\r\n\t\tfont-weight: bold;\r\n\t\tfont-size: 16pt;\r\n\t}\r\n\r\n\t.dialogBody\r\n\t{\r\n\t\tpadding: 0px 5px 0px 5px;\r\n\t}\r\n\r\n\t.buttons\r\n\t{\r\n\t\tdisplay: flex;\r\n\t}\r\n\r\n\t.dialogButton\r\n\t{\r\n\t\tdisplay: inline-block;\r\n\t\tcursor: pointer;\r\n\t\tcolor: #4A9E42;\r\n\t\tfont-weight: bold;\r\n\t\tfont-size: 12pt;\r\n\t\tbox-sizing: border-box;\r\n\t\tposition: relative;\r\n\t\tpadding: 12px 5px;\r\n\t\tflex: 1 0 auto;\r\n\t\ttext-align: center;\r\n\t}\r\n\r\n\t\t.dialogButton:hover\r\n\t\t{\r\n\t\t\tbackground-color: rgba(0,0,0,0.05);\r\n\t\t}\r\n\r\n\t.embedded\r\n\t{\r\n\t\tmargin: 10px 5px;\r\n\t}\r\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
